import React from "react"
import { Box, Heading, Text } from "@chakra-ui/react"
import { graphql, useStaticQuery } from "gatsby"
import ReviewAddProductCard from "@app/components/Product/Review/Add/ReviewAddProductCard"
import { ProductCombinedProps, ProductProps } from "@root/types/global"

type Props = {
  product: ProductCombinedProps
  swatches?: Array<ProductProps>
}

const ReviewAddHeader: React.FC<Props> = ({ product, swatches }) => {
  const { locales } = useStaticQuery<GatsbyTypes.ReviewSectionAddHeaderQuery>(graphql`
    query ReviewSectionAddHeader {
      locales: sanityTemplateProduct {
        additionReviewDrawHeaderTitle
        additionReviewDrawHeaderBody
      }
    }
  `)

  return (
    <Box paddingX={{ base: 6, md: 8 }} paddingY={8} width={"100%"}>
      <Box width={{ base: "full", md: "50%" }}>
        <Heading
          size="lg"
          mb={{ base: 1, md: 2 }}
          textTransform="none"
          color="grey.text"
          fontSize={{ base: "24px", md: "32px" }}
          fontStyle="normal"
          fontWeight={500}
          lineHeight="32px"
          whiteSpace={"nowrap"}
        >
          {locales?.additionReviewDrawHeaderTitle}
        </Heading>
        <Text color="grey.text" fontSize="14px" fontStyle="normal" fontWeight={400} lineHeight="24px" letterSpacing="0.75px">
          {locales?.additionReviewDrawHeaderBody}
        </Text>
      </Box>
      <ReviewAddProductCard product={product} swatches={swatches} />
    </Box>
  )
}

export default ReviewAddHeader
